export default __webpack_public_path__ + "static/media/Lying.24bb5de9.svg";